import React, { useEffect, useState, FC } from "react";
import { toast } from 'react-toastify';
import { Button, Modal, Grid } from 'semantic-ui-react';
import { config } from '../../contexts/UrlContext';

interface IProps {
    open: boolean,
    onChange: any,
    onClose: any
}

const EPathwayLinkModal: FC<IProps> = ({ open, onChange, onClose }) => {

    useEffect(() => {
    }, []);

    return (
        <Modal
            id="iFrameModal"
            open={open}
            onClose={onClose} >
            <Modal.Header>Configure Pathway Link Settings</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <div style={{marginBottom:10}}>Select the ePathway link type </div>
                    <div style={{display:"grid"}}>
                        <Button style={{ marginBottom: 5 }} onClick={() => onChange("ShortLink")}>Create Short Link</Button>
                        <Button style={{ marginBottom: 5 }} onClick={() => onChange("StandardLink")}>Create Standard Link</Button>
                        <Button style={{ marginBottom: 5 }} onClick={() => onChange("DynamicLink")}>Create Dynamic Link</Button>
                    </div>
                </Modal.Description>
            </Modal.Content>
        </Modal>
    )
}

export default EPathwayLinkModal;